<template>
  <div>
    <input
      type="text"
      v-model="map.title"
      class="text-field w-input"
      :placeholder="[fname]"
      @input="findLocation()"
    />
    <!-- <GmapMap
      v-if="showMap"
      :options="{
   zoomControl: true,
   mapTypeControl: false,
   scaleControl: false,
   streetViewControl: false,
   rotateControl: false,
   fullscreenControl: true,
   disableDefaultUi: false
 }"
    ></GmapMap>-->
  </div>
</template>

<script>
export default {
  name: "Map",
  props: ["slg", "fname", "value"],
  data() {
    return {
      debaunce: "",
      showMap: false,
      map: {
        title: this.value ? this.value.title : ""
        // location: this.value ? this.value.location : {}
      }
    };
  },
  methods: {
    findLocation() {
      this.$emit("input", this.map);
      //   clearTimeout(this.debaunce);
      //   this.debaunce = setTimeout(() => {
      //     // $.getJSON(
      //     //   `https://maps.googleapis.com/maps/api/place/findplacefromtext/json?input=${encodeURIComponent(
      //     //     this.map.title
      //     //   )}&inputtype=textquery&fields=photos,formatted_address,name,opening_hours,rating&locationbias=circle:2000@47.6918452,-122.2226413&key=AIzaSyBC2GSa1WxwRXqzsVJxRmJ-3pv1PrEMBlc`,
      //     //   res => {
      //     //     console.log(res);
      //     //   }
      //     // );
      //     console.log(this.map.title);
      //     this.showMap = true;
      //   }, 2000);
    }
  }
};
</script>
